import { Component, Input } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { ChronologyEvent } from './ChronologyEvent';

@Component({
   selector: 'app-ngx-chronology',
   templateUrl: './chronology.component.html',
   styleUrls: ['./chronology.component.scss'],
})
export class ChronologyComponent
{
   @Input() public events: Array<ChronologyEvent>;
   @Input() public title: string;

   constructor(
      public intl: IntlService
   ) { }

   public getIcon(entry: ChronologyEvent): string
   {
      if (!entry.icon)
      {
         switch (entry.type)
         {
            case 'CASE_OPENED':
               return 'far icon case-opened';
            case 'TASK_OPENED':
               return 'far icon task-activity';
            case 'FOLLOW_UP_TASK_OPENED':
               return 'far icon task-activity';
            case 'TASK_ASSIGNED':
               return 'far icon task-activity';
            case 'TASK_MODIFIED':
               return 'far icon task-activity';
            case 'TASK_UNASSIGNED':
               return 'far icon task-activity';
            case 'TASK_PRIORITY_CHANGED':
               return 'far icon task-activity';
            case 'CASE_BILLABLE_SERVICE_CREATED':
               return 'far icon task-activity-billable';
            case 'TASK_RESCHEDULED':
               return 'far icon task-activity';
            case 'TASK_COMPLETED':
               return 'far icon task-completed';
            default:
               return 'far icon case-activity'; // default icon, if not specified.
         }
      }
      else
      {
         return entry.icon + ' icon';
      }
   }

   public getDirection(entry: ChronologyEvent): string
   {
      switch (entry.type)
      {
         case 'MESSAGE_RECEIVED':
         case 'CASE_MANAGER_CHANGED':
         case 'CASE_STATUS_CHANGED':
         case 'CASE_PRIORITY_CHANGED':
         case 'CASE_WORKFLOW_STATUS_CHANGED':
         case 'CASE_SENSITIVITIES_CHANGED':
         case 'TASK_PRIORITY_CHANGED':
         case 'TASK_RESCHEDULED':
         case 'CASE_BILLABLE_SERVICE_CREATED':
         case 'DOCUMENT_ATTACHED':
            return 'panel right';
         default:
            return 'panel left'; // default icon, if not specified.
      }
   }
}
